// export const DEFAULT_POMODORO_TIME_MINUTES = 25;
export const DEFAULT_POMODORO_TIME_MINUTES = 0.5;
// export const DEFAULT_BREAK_TIME_MINUTES = 5;
export const DEFAULT_BREAK_TIME_MINUTES = 0.5;
// export const BIG_BREAK_TIME_MINUTES = 25;
export const BIG_BREAK_TIME_MINUTES = 2;
export const BIG_BREAK_NUMBER = 4;

export const MAX_TIMER_TIME_SECONDS = 60 * 60;
export const ADDED_TIMER_TIME_SECONDS = 60;
// export const TIMER_STEP_MS = 1000;
export const TIMER_STEP_MS = 100;

export const MAX_NAME_LENGTH = 61;

export const COLOR_PRIMARY_DARK = '#899441';
export const COLOR_PRIMARY = '#A8B64F';

export const COLOR_SECONDARY_DARK = '#B7280F';
export const COLOR_SECONDARY = '#DC3E22';
export const COLOR_SECONDARY_LIGHT = '#EE735D';
export const COLOR_SECONDARY_LIGHTER = '#EA8979';

export const COLOR_GRAY_DARK = '#999';
export const COLOR_GRAY = '#C4C4C4';
export const COLOR_GRAY_LIGHT = '#E4E4E4';
export const COLOR_GRAY_LIGHTER = '#F4F4F4';

export const COLOR_BLACK = '#333';

export const COLOR_WHITE = 'white';
